import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
// import Loader from "../../components/loader/loader";
import { get } from "../../hooks/services/service";
import { FaArrowLeft } from "react-icons/fa";
import { patchData } from "../../hooks/api/utils";

const OrderDetail = () => {
  const location = useLocation();
  const { orderId } = location.state || {};
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!orderId) {
      setError("No order ID provided.");
      setLoading(false);
      return;
    }
    fetchOrderDetail();
  }, [orderId]);

  const MONTHS_MAP = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  };

  const getMonthName = (monthNumber) => MONTHS_MAP[monthNumber] || '';

  const fetchOrderDetail = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await get("admin-panel/order-detail/", {
        order_id: orderId,
      });
      const data = res?.data.order;
      setOrder(data);
    } catch (err) {
      console.error("Failed to fetch order detail:", err);
      setError("Failed to load order details.");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => navigate("/orders");

  const orderItems = order?.order_items || [];

  const handleCancel = async (id) => {
    const cancelData = await patchData(
      `/payments/cancel-recurring/`,
      { item_id: id },
      setLoading
    );
    if (cancelData) {
      fetchOrderDetail();
    }
  };

  return (
    <div className="rightContent">
      <div className="viewMain">
        <div className="row">
          <div className="col-md-12 bg-white left-col p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4>Order Detail</h4>
              <button
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={handleBack}
              >
                <FaArrowLeft /> Back to Orders
              </button>
            </div>

            {/* {loading ? (
                
                <Loader /> 
              ) :  */}
            {error ? (
              <div className="alert alert-danger">{error}</div>
            ) : !order && !loading ? (
              <div className="alert alert-warning">Order not found.</div>
            ) : (
              <>
                <h5 className="mt-5 mb-3">Ordered Services</h5>
                {orderItems.length > 0 ? (
                  <div className="table-responsive">
                    {orderItems.map((item, index) => (
                      <div
                        key={item.id}
                        className="border rounded mb-4 p-3 shadow-sm position-relative"
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="mb-3 fs-5 fw-bold">
                            {item.service_name}
                          </h6>
                          {item?.cancel && (
                            <div
                              className="remove text-decoration-none cursor-pointer"
                              onClick={() => handleCancel(item?.id)}
                            >
                              Cancel Recurring
                            </div>
                          )}
                        </div>
                        <table className="table">
                                <thead>
                                  <tr>
                                    <th>Attribute</th>
                                    <th>Value</th>
                                    <th>Details</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>Area</td>
                                    <td>{item.area_ha} ha</td>
                                    <td>—</td>
                                  </tr>
                                  <tr>
                                    <td>Price of service</td>
                                    <td>
                                      ${item.price}{' '}
                                      {item?.price_type === 'Tiered'
                                        ? 'per ha'
                                        : ''}
                                    </td>
                                    <td>
                                      {item.area_ha}{' '}
                                      {item?.price_type === 'Tiered'
                                        ? `x ${item.price}`
                                        : ''}{' '}
                                      = ${item.amount.toFixed(2)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Image Included</td>
                                    <td>{item.with_image ? 'Yes' : 'No'}</td>
                                    <td>
                                      {item.with_image
                                        ? `$${item.image_price}`
                                        : '—'}
                                    </td>
                                  </tr>
                                  {item?.vegetation_type && (
                                    <tr>
                                      <td>Vegetation Type</td>
                                      <td>{item.vegetation_type}</td>
                                      <td></td>
                                    </tr>
                                  )}
                                  {item?.soil_type && (
                                    <tr>
                                      <td>Soil Type</td>
                                      <td>{item.soil_type}</td>
                                      <td></td>
                                    </tr>
                                  )}

                                  {item?.historical &&
                                    item?.historical_data?.length > 0 && (
                                      <tr>
                                        <td>Historical Data</td>
                                        <td colSpan="2">
                                          <div
                                            className="d-flex flex-wrap gap-2"
                                            style={{ rowGap: '10px' }}
                                          >
                                            {item?.historical_data.map(
                                              (h, idx) => (
                                                <div
                                                  key={idx}
                                                  className="px-2 py-1 rounded"
                                                  style={{
                                                    background: 'transparent',
                                                    border: '1px solid #589a5b',
                                                    fontSize: '1rem',
                                                    color: '#589a5b',
                                                    whiteSpace: 'nowrap',
                                                    borderRadius: '25px',
                                                    flexShrink: 0,
                                                  }}
                                                >
                                                  {h.month} {h.year}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    )}

                                  {item?.risk_assessment && (
                                    <>
                                      <tr>
                                        <td>Risk Period</td>
                                        <td>
                                          {getMonthName(
                                            item?.risk_assessment_data
                                              ?.start_month
                                          )}{' '}
                                          –{' '}
                                          {getMonthName(
                                            item?.risk_assessment_data
                                              ?.end_month
                                          )}{' '}
                                          {item?.risk_assessment_data?.year}
                                        </td>
                                        <td></td>
                                      </tr>
                                    </>
                                  )}

                                  {item?.recurring && (
                                    <>
                                      <tr>
                                        <td>Recurring</td>
                                        <td>Yes</td>
                                        <td></td>
                                      </tr>
                                      {item?.recurring_days && (
                                        <tr>
                                          <td>Recurring Week</td>
                                          <td>{item.recurring_days}</td>
                                          <td></td>
                                        </tr>
                                      )}
                                      {item?.recurring_times && (
                                        <tr>
                                          <td>Recurring Times</td>
                                          <td>{item.recurring_times}</td>
                                          <td>
                                            {item.recurring_times + 1} × $
                                            {item.calculated_price.toFixed(2)} =
                                            ${item.estimated_amount.toFixed(2)}
                                          </td>
                                        </tr>
                                      )}
                                    </>
                                  )}
                                  <tr>
                                    <td colSpan="2" className="fw-bold">
                                      Estimated Amount
                                    </td>
                                    <td className="fw-bold">
                                      ${item.estimated_amount.toFixed(2)}
                                    </td>
                                  </tr>

                                  {item?.refunds && (
                                    <>
                                      <tr>
                                        <td
                                          colSpan="3"
                                          className="bg-light fw-bold text-start"
                                        >
                                          Recurring Payment Refund
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Refund Amount</td>
                                        <td colSpan="2">
                                          $
                                          {item?.refunds?.refund_amount?.toFixed(
                                            2
                                          ) || '0.00'}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Refund Recurring Time</td>
                                        <td colSpan="2">
                                          {item?.refunds?.recurring_times || 0}
                                        </td>
                                      </tr>
                                    </>
                                  )}
                                </tbody>
                              </table>
                        {item?.analysis_status == "Completed" && (
                          <div className="d-flex justify-content-end">
                            <Link
                              to={"/analysis-report"}
                              state={{ id: item?.id, orderId: orderId }}
                              className="blue_btn"
                            >
                              View Analysis Report
                            </Link>
                          </div>
                        )}
                      </div>
                    ))}
                    {order?.billing_address && (
                      <div className="border rounded mb-4 p-3 shadow-sm">
                        <h4 className="fs-4 fw-bold text-start w-100">
                          Biiling Address
                        </h4>
                        <p className="d-flex flex-wrap w-100 justify-content-start align-items-center">
                          {order?.billing_address?.address_line_1},{" "}
                          {order?.billing_address?.city},{" "}
                          {order?.billing_address?.state},{" "}
                          {/* {order?.billing_address?.district},{" "} */}
                        </p>
                        <p className="d-flex flex-wrap w-100 justify-content-start align-items-center">
                          {order?.billing_address?.country}-{" "}
                          {order?.billing_address?.postal_code}
                        </p>
                      </div>
                    )}
                    {/* Payments */}
                    {order?.payments && (
                      <div className="card text-end p-2 card-borderRadius">
                        {order.payments.wallet_amount > 0 && (
                          <>
                            <div className="fs-5">
                              <span className="fw-bold fs-5">Amount:</span> $
                              {order.payments.amount.toFixed(2)}
                            </div>
                            <div className="fs-5">
                              <span className="fw-bold fs-5">Wallet:</span> $
                              {order.payments.wallet_amount.toFixed(2)}
                            </div>
                            <hr />
                          </>
                        )}
                        <div className="fs-5">
                          <span className="fw-bold fs-5">Total Price:</span> $
                          {order.total.toFixed(2)}
                        </div>
                      </div>
                    )}

                    {/* Recurring Payment Reference */}
                    {order?.order_id && (
                      <div className="card shadow-sm p-3">
                        <h6 className="mb-1">Recurring Payment Reference</h6>
                        <small className="text-muted">
                          First Order ID: #{order.order_id}
                        </small>
                        <div className="mt-2">
                          <Link
                            to={"/order-detail"}
                            state={{ orderId: order.order_id }}
                            className="btn btn-primary btn-sm"
                          >
                            View Reference Order
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-muted">
                    No services found for this order.
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;
